/**
 * Zona táctil ampliada sin cambiar el aspecto (B2 · H04): un pseudo-elemento
 * transparente centrado sobre el control que llega al mínimo táctil
 * (44 px a escala 1). Uso con Emotion: `className={css(zonaTactil())}` o
 * mezclándolo en el objeto de estilos de un `View`/`Button`.
 *
 * El control necesita `position: relative` (se incluye) y no debe recortar
 * su contenido (`overflow: hidden` ocultaría la zona ampliada).
 */
export const MINIMO_TACTIL = 44;

export function zonaTactil(minimo: number = MINIMO_TACTIL) {
  return {
    position: 'relative' as const,
    '&::before': {
      content: '""',
      position: 'absolute' as const,
      top: '50%',
      left: '50%',
      width: `max(100%, ${minimo}px)`,
      height: `max(100%, ${minimo}px)`,
      transform: 'translate(-50%, -50%)',
      background: 'transparent',
    },
  };
}

/**
 * Zona táctil que crece solo hacia un lado (o hacia los dos con medidas
 * distintas) y con un alto fijo centrado: para botones pegados entre sí
 * (zZ y ✓ de la fila del Plan), donde la zona centrada de uno pisaría al
 * otro. `izquierda`/`derecha`: px que sobresale por cada lado.
 */
export function zonaTactilLateral({
  izquierda = 0,
  derecha = 0,
  alto = MINIMO_TACTIL,
}: {
  izquierda?: number;
  derecha?: number;
  alto?: number;
}) {
  return {
    position: 'relative' as const,
    '&::before': {
      content: '""',
      position: 'absolute' as const,
      top: '50%',
      left: izquierda ? -izquierda : 0,
      right: derecha ? -derecha : 0,
      height: `max(100%, ${alto}px)`,
      transform: 'translateY(-50%)',
      background: 'transparent',
    },
  };
}

/**
 * `ref` de un campo que debe abrir el teclado al aparecer (la hoja se abre
 * para escribir). Estable: React la llama solo al montar el campo.
 */
export function enfocarAlMontar(campo: HTMLInputElement | null): void {
  campo?.focus();
}
